import { render, staticRenderFns } from "./ExpressionOfInterestFileDeleteDialog.vue?vue&type=template&id=810da2f0&"
import script from "./ExpressionOfInterestFileDeleteDialog.vue?vue&type=script&lang=ts&"
export * from "./ExpressionOfInterestFileDeleteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports